<template>

  <div class="tes-articles__pagination-more-wrapper" v-if="pagination && pagination.totalPages() > 1">
    <router-link :to="urlPattern.replace(':page', (1 + pagination.currentPage()).toString())"
                 class="tes-articles__pagination-more-link"
                 v-if="!pagination.isLastPage()">показать больше
    </router-link>
    <span class="tes-articles__pagination-more-link" v-else>больше нет</span>
  </div>

  <ul class="tes-articles__pagination-list-wrapper" v-if="pagination && pagination.totalPages() > 1">

    <li class="tes-articles__pagination-list-item tes-articles__pagination-list-item_first">
      <router-link class="tes-articles__pagination-list-item-link"
                   :to="prepareFirstPageUrl()"
                   v-if="!pagination.isFirstPage() || startFromZero" @click="changePage(1)"><span
        class="tes-articles__pagination-list-item-text">«</span></router-link>
      <span class="tes-articles__pagination-list-item-link" v-else>
          <span class="tes-articles__pagination-list-item-text">«</span>
      </span>
    </li>

    <li class="tes-articles__pagination-list-item tes-articles__pagination-list-item_prev">
      <router-link class="tes-articles__pagination-list-item-link"
                   :to="preparePrevPageUrl"
                   v-if="!pagination.isFirstPage() || startFromZero" @click="changePage(1)"><span
        class="tes-articles__pagination-list-item-text">‹</span></router-link>
      <span class="tes-articles__pagination-list-item-link" v-else>
          <span class="tes-articles__pagination-list-item-text">‹</span>
        </span>
    </li>

    <li
      :class="['tes-articles__pagination-list-item', (pagination.currentPage() === number)?'tes-articles__pagination-list-item_selected':'']"
      v-for="number of visiblePages()">
      <router-link
        :to="preparePageUrl(number)"
        class="tes-articles__pagination-list-item-link"
        v-if="pagination.currentPage() !== number"
        @click="changePage(number)"
      ><span
        class="tes-articles__pagination-list-item-text">{{ number.toString() }}</span></router-link>
      <span class="tes-articles__pagination-list-item-link"
            v-else>{{number.toLocaleString()}}</span>
    </li>

    <li class="tes-articles__pagination-list-item tes-articles__pagination-list-item_next">
      <router-link class="tes-articles__pagination-list-item-link"
                   :to="urlPattern.replace(':page', pagination.nextPage().toString())"
                   v-if="!pagination.isLastPage()"><span
        class="tes-articles__pagination-list-item-text">›</span></router-link>
      <span class="tes-articles__pagination-list-item-link" v-else>
          <span class="tes-articles__pagination-list-item-text">›</span>
        </span>
    </li>

    <li class="tes-articles__pagination-list-item tes-articles__pagination-list-item_last">
      <router-link class="tes-articles__pagination-list-item-link"
                   :to="urlPattern.replace(':page', pagination.lastPage().toString())"
                   v-if="!pagination.isLastPage()"><span
        class="tes-articles__pagination-list-item-text">»</span></router-link>
      <span class="tes-articles__pagination-list-item-link" v-else>
          <span class="tes-articles__pagination-list-item-text">»</span>
        </span>
    </li>

  </ul>

</template>

<script lang="ts">

import {PaginationInterface} from '../../objects/Paginator'
import {computed, PropType} from 'vue'

export default {
  name: 'PostsPagination',
  props: {
    pagination: {
      type: Object as PropType<PaginationInterface>,
      required: true
    },
    urlPattern: {
      type: String,
      required: true
    },
    countShowPages: {
      type: Number,
      default: 10
    },
    startFromZero: {
      type: Boolean,
      default: false
    }
  },
  emits: ['changePage', 'changePerPage'],
  setup(props, {emit}) {

    const prepareFirstPageUrl = () : string => {
      let i
      let p = props.urlPattern.replace('/:page', '')
      p = p.replace('/page', '')
      if(p.length - 2 >= -1 && (i = p.indexOf('//')) === p.length - 2) {
        p = p.substring(0, i + 1)
      }
      return p;
    }

    const preparePrevPageUrl = computed(() : string => {
      return props.pagination.prevPage() <= 0
        ? prepareFirstPageUrl()
        : preparePageUrl(props.pagination.prevPage())
    })

    const preparePageUrl = (number: number): string  => {
      return number === 1 && !props.startFromZero
        ? prepareFirstPageUrl()
        : props.urlPattern.replace(':page', number.toString())
    }

    const visiblePages = (): Array<number> => {
      let start: number = 1
      let end: number = Math.min(props.countShowPages, props.pagination?.totalPages())
      if (props.countShowPages < props.pagination?.totalPages()) {
        start = props.pagination?.currentPage()
        if (start - props.countShowPages / 2 > 0) {
          start -= props.countShowPages / 2
        }
        end = start + props.countShowPages;
        if (end > props.pagination?.totalPages()) {
          end = props.pagination?.totalPages()
        }
      }
      let tmp: Array<number> = []
      for (let i = start; i <= end; i++) {
        tmp.push(i)
      }
      return tmp
    }

    visiblePages()

    const changePage = (num: number) => {
      emit('changePage', num)
    }

    return {
      prepareFirstPageUrl, preparePrevPageUrl, preparePageUrl, visiblePages,
      changePage
    }
  }
}
</script>
